var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 37.8,
  width: 34,
  height: 1.6,
  rx: 0.8,
  fill: "#c3ccd2"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 11.5,
  r: 6,
  fill: "#dfe6ec"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.8,
  cy: 12,
  r: 3.6,
  fill: "#e8b48e"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 16.2,
  y: 9.8,
  width: 5.4,
  height: 1.9,
  rx: 0.95,
  fill: "#46626d"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 12.2,
  width: 5.8,
  height: 3.4,
  rx: 1.5,
  fill: "#4fb3c6"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 13,
  y: 17,
  width: 10,
  height: 13,
  rx: 4,
  fill: "#dfe6ec"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 17.6,
  y: 18,
  width: 0.9,
  height: 7,
  rx: 0.45,
  fill: "#b9c6cf"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 29.5,
  width: 3.4,
  height: 8.6,
  rx: 1.4,
  fill: "#dfe6ec"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 18.6,
  y: 29.5,
  width: 3.4,
  height: 8.6,
  rx: 1.4,
  fill: "#dfe6ec"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m14 36.2h4.2c1 0 1.4 0.4 1.4 0.9 0 0.4-0.3 0.7-0.7 0.7h-4.9z",
  fill: "#8fb6c9"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m18.6 36.2h4.2c1 0 1.4 0.4 1.4 0.9 0 0.4-0.3 0.7-0.7 0.7h-4.9z",
  fill: "#8fb6c9"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m31.5 15.5-7 19",
  fill: "none",
  stroke: "#9aa7b0",
  strokeWidth: 1.8,
  strokeLinecap: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 21,
  y: 18.4,
  width: 8.6,
  height: 2.7,
  rx: 1.35,
  fill: "#dfe6ec",
  transform: "rotate(33.5 21.5 19.7)"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 22.4,
  width: 8,
  height: 2.7,
  rx: 1.35,
  fill: "#dfe6ec",
  transform: "rotate(38.3 20.5 23.7)"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 28.3,
  cy: 24,
  r: 1.7,
  fill: "#5a8fd8"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 26.7,
  cy: 28.4,
  r: 1.7,
  fill: "#5a8fd8"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 20.3,
  y: 34.9,
  width: 9.2,
  height: 3,
  rx: 1.5,
  fill: "#c9d3da"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m35.5 22.6 0.95 1.85 1.85 0.95-1.85 0.95-0.95 1.85-0.95-1.85-1.85-0.95 1.85-0.95z",
  fill: "#7fd1c0"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "m39 30.4 0.7 1.35 1.35 0.7-1.35 0.7-0.7 1.35-0.7-1.35-1.35-0.7 1.35-0.7z",
  fill: "#7fd1c0"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "m8.5 19.2 0.7 1.35 1.35 0.7-1.35 0.7-0.7 1.35-0.7-1.35-1.35-0.7 1.35-0.7z",
  fill: "#7fd1c0"
});

function SvgGmpCleaningStaff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmpCleaningStaff);
export default __webpack_public_path__ + "static/media/gmp-cleaning-staff.fee90b4682012799ffdbd53eacb7e200.svg";
export { ForwardRef as ReactComponent };